module.exports = __webpack_public_path__ + "img/fasapay.fdffdb6a.png";